// src/services/aparelho.js -- identificador estavel deste aparelho.
//
// Por que existe: o push de venda sai por dois canais durante o dual-run da F4
// (FCM e Web Push VAPID). O backend precisa saber que os dois registros sao do
// MESMO aparelho, senao o operador recebe o aviso duas vezes -- foi o que
// aconteceu em producao em 11/09/2026, em 7 depositos, quando o pareamento so
// existia no nivel do usuario e nao distinguia celular de desktop.
//
// E' o mesmo `visitorId` do FingerprintJS que o Modo Hack ja manda nos dois
// registros (hybezbet-vue/src/App.vue). A lib ja era dependencia deste repo,
// so nao estava em uso.
import FingerprintJS from '@fingerprintjs/fingerprintjs';

// Uma resolucao por carregamento de pagina: o FingerprintJS custa alguns
// milissegundos e e' chamado de tres pontos do boot (DashboardView e as duas
// entradas de PushNotification).
let promessaDoVisitante = null;

/**
 * Identificador deste aparelho, ou `null` se a lib falhar.
 *
 * Nunca rejeita: quem chama usa o valor para PAREAR dois registros de push, e
 * ficar sem ele custa um aviso duplicado, nao uma tela quebrada.
 *
 * Exemplo:
 *   const deviceId = await identificarAparelho();  // 'a3f9...'
 */
export function identificarAparelho() {
  if (!promessaDoVisitante) {
    promessaDoVisitante = FingerprintJS.load()
      .then((fp) => fp.get())
      .then((resultado) => resultado.visitorId)
      .catch((erro) => {
        console.warn(JSON.stringify({ evento: 'device_id_falhou', erro: String(erro) }));
        return null;
      });
  }
  return promessaDoVisitante;
}
